const Google = () => (
    <svg width="35px" viewBox="0 0 35 35">
        <path
            d="M17.5068 6.76632C20.7949 6.76632 23.0128 8.18578 24.2776 9.37186L29.2194 4.54981C26.1842 1.73041 22.2346 0 17.5068 0C10.6584 0 4.74371 3.92757 1.86426 9.64394L7.52584 14.0383C8.94621 9.81893 12.8763 6.76632 17.5068 6.76632Z"
            fill="#EA4335"
        />
        <path
            d="M34.3202 17.8879C34.3202 16.4491 34.2035 15.3991 33.9505 14.3103H17.5103V20.8044H27.1605C26.9659 22.4182 25.9152 24.8487 23.5805 26.4819L29.106 30.7596C32.4136 27.7068 34.3202 23.2154 34.3202 17.8879Z"
            fill="#4285F4"
        />
        <path
            d="M7.54903 20.9619C7.17929 19.8731 6.96529 18.7063 6.96529 17.5009C6.96529 16.2953 7.17929 15.1287 7.5295 14.0399L1.86773 9.64557C0.681056 12.0177 0 14.6815 0 17.5009C0 20.3201 0.681056 22.9841 1.86773 25.3561L7.54903 20.9619Z"
            fill="#FBBC05"
        />
        <path
            d="M17.5157 34.9999C22.2435 34.9999 26.2125 33.4445 29.1114 30.7613L23.5859 26.4837C22.1073 27.5141 20.1227 28.2336 17.5157 28.2336C12.8852 28.2336 8.95515 25.1808 7.55432 20.9617L1.89258 25.3558C4.77202 31.0724 10.6671 34.9999 17.5157 34.9999Z"
            fill="#34A853"
        />
    </svg>
);

export default Google;
